module.exports = __webpack_public_path__ + "static/media/sf-trial-correct.63073a88.mp3";